import { useEffect, useState } from 'preact/hooks'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'
import Icon from '../icon/icon'

function SwymNotice() {
  const [type, setType] = useState('standard')
  const [content, setContent] = useState('')
  const [classCustom, setClassCustom] = useState('')
  const [isDisplayed, setIsDisplayed] = useState(false)
  const [timeoutId, setTimeoutId] = useState('')

  useEffect(() => {
    globalEmitter.on(emitterProps.wishlist.global, (value) => {
      if (value.type) {
        setType(value.type)
      }

      if (value.content) {
        setContent(value.content)
      }
      setIsDisplayed(true)

      if (value.duration) {
        setTimeoutId(setTimeout(() => {
          setIsDisplayed(false)
        }, value.duration))
      } else {
        setTimeoutId(setTimeout(() => {
          setIsDisplayed(false)
        }, 5000))
      }

      if (value.classCustom) {
        setClassCustom(value.classCustom)
      }
    })
  }, [])

  const handleClose = () => {
    clearTimeout(timeoutId)
    setIsDisplayed(false)
  }

  return (
    <div className={`fixed left-0 right:0 z-30 w-full flex justify-center -bottom-full ${isDisplayed ? 'opacity-1 visible animation-bottom' : 'opacity-0 invisible'}`}>
      <div className='flex items-center gap-2 m-auto p-2.5 backdrop-blur-xl bg-blur'>
        <Icon
          name='icon-heart'
          viewBox='0 0 20 20'
          className='w-4 h-4 text-default fill-black'
        />
        <div dangerouslySetInnerHTML={{ __html: content }} className='' />
      </div>

    </div>
  )
}

export default SwymNotice
